/**
 * humaninterval - Created by karora on 16/03/17.
 */
import { Pipe, PipeTransform } from '@angular/core';


/*
 * Format a number of seconds into a MM:SS.ddd
 */
@Pipe({ name: 'secs' })
export class SecsPipe implements PipeTransform {
  transform(interval: number): string {
    if (isNaN(interval)) {
      return "??.?";
    }
    if (interval > 900) {
      interval /= 1000;
    }
    let tenths = Math.round(interval * 10);
    let result: string = '' + Math.trunc((tenths + 0.001) / 10);
    result += "." + (tenths % 10);
    return result;
  }
}
